import React, { useEffect } from "react";
import RefreshIcon from "@material-ui/icons/Refresh";
import InputDropdown from "./input-dropdown";
import store from "src/store";

export default function EngagementManagerFilters(props) {

    useEffect(() => {
        store.checkAndSetEngagementManagerFilter();
    }, [store.engagements]);

    const getAllOrganisationList = () => {
        let organizations = [];

        if (store.userOrganizations.length) {
            organizations = store.userOrganizations.map((item) => {
                return {
                    label: item.name,
                    value: item._id
                }
            });
        }

        organizations.unshift({
            label: 'All',
            value: 'All'
        });

        return organizations;
    }

    store.useRerenderIfChange(() => [store.engagementManagerFilter, store.userOrganizations])

    return (
        <>
            <div css="
                display: flex; 
                align-items: center;
                width: 100%;
                justify-content: start;
            ">
                <div css="width: 20%; margin-right: 15px">
                    <InputDropdown
                        id={"organization"}
                        label={"Filter by organization"}
                        value={store.engagementManagerFilter.orgId}
                        disabled={false}
                        showClearOption={store.engagementManagerFilter.orgId != 'All'}
                        onClear={() => { store.updateEngagementManagerFilter('orgId', 'All') }}
                        onChange={(value) => { store.updateEngagementManagerFilter("orgId", value) }}
                        list={getAllOrganisationList()}
                    />
                </div>
                <div
                    css={`cursor:pointer;display:flex; align-items: center; flex-direction: column; width: max-content; position:relative; bottom: 5px`}
                    title="Refresh"
                    onClick={() => {
                        store.resetEngagementManagerFilter()
                    }}
                >
                    <RefreshIcon style={{ color: '#000', marginTop: '13px' }} />
                    <div css={`width: max-content`}>Refresh</div>
                </div>
            </div>
        </>
    )

}